import { any, number } from 'prop-types';
import React from 'react';

import { SHIPPING_INFO_ICON_CLASS } from '@utils/constant';

const BOShippingInfoLayout = ({ children, name, shippingOptionType, wrapperClassName = '' }) => {
  return (
    <div className={['shipping-info__item shipping-info--delivery', wrapperClassName].join(' ')}>
      {shippingOptionType !== null ? (
        <div className='shipping-info__item__icon'>
          <div className={['fulfillment-icon', SHIPPING_INFO_ICON_CLASS[shippingOptionType] ?? ''].join(' ')}></div>
        </div>
      ) : (
        <></>
      )}
      <div className='shipping-info__item__text'>
        {name ? <span className='shipping-info__item__text__title'>{name}</span> : <></>}
        {/* <span className='shipping-info__item__text__desc'>{DELIVERY_OPTION.ShipItem !== shippingOptionType ? deliveryItem.Description : null}</span> */}

        {children}
      </div>
    </div>
  );
};

BOShippingInfoLayout.propTypes = {
  children: any,
  name: any,
  shippingOptionType: number,
  wrapperClassName: any
};

export default BOShippingInfoLayout;